var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.details.owner,
          expression: "details.owner",
        },
      ],
      staticClass: "d-flex flex-lg-row flex-column align-items-center",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "dropdown dropdown-owner ml-xl-3 ml-0 d-flex align-items-center",
          attrs: { "data-placement": "bottom" },
        },
        [
          _c(
            "button",
            {
              staticClass:
                "btn btn-white d-flex flex-row align-items-center dropdown-toggle",
              staticStyle: { "white-space": "normal" },
              attrs: { "data-toggle": "dropdown" },
            },
            [
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.atLeastOneTrackingOn
                  ? _c(
                      "div",
                      {
                        ref: "assignee-tooltip",
                        staticClass: "thumbnail-group",
                      },
                      _vm._l(
                        _vm.firstThreeCollaborators,
                        function (thumbnail, index) {
                          return _c(
                            "div",
                            {
                              key: "thumbnail-" + index,
                              staticClass: "thumbnail-item",
                            },
                            [
                              _c(
                                "profile-avatar",
                                _vm._b(
                                  {
                                    staticClass: "client-profile-owner-avatar",
                                    class: { "mr-2": index > 0 },
                                    attrs: {
                                      "avatar-options": { inline: false },
                                    },
                                  },
                                  "profile-avatar",
                                  Object.assign({}, thumbnail),
                                  false
                                )
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    )
                  : _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.right",
                            value: _vm.$t(
                              "client-profile.messages.noEmailTrackingAdded"
                            ),
                            expression:
                              "\n            $t('client-profile.messages.noEmailTrackingAdded')\n          ",
                            modifiers: { right: true },
                          },
                        ],
                        ref: "no-tracking-tooltip",
                        staticClass: "text-light-gray",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-user-times",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "d-none" }, [
                _vm._v(_vm._s(_vm.$t("email.messages.emailTracking"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "dropdown-menu client-profile-collaborators-dropdown",
            },
            [
              _c("div", { staticClass: "dropdown-item dropdown-item-fake" }, [
                _c(
                  "form",
                  { attrs: { autocomplete: "off" } },
                  [
                    _c("collaborators-select", {
                      attrs: {
                        profile: _vm.profile,
                        "board-id": _vm.boardId,
                        "client-profile-id": _vm.clientProfileId,
                        value: _vm.currentCollaborators,
                      },
                      on: {
                        change: _vm.handleChange,
                        submit: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              Object.keys(_vm.profileCollaborators).length
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "dropdown-divider" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-item d-flex align-items-center no-pointer dropdown-item-fake",
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "small text-uppercase ml-auto mb-0 text-right py-0",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$tc("global.doorr.agent", 2)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.profileCollaborators, function (collaborator) {
                        return _c("collaborator-item", {
                          key: collaborator.username,
                          attrs: {
                            id: collaborator.name + "-id",
                            user: collaborator,
                            checked: collaborator.trackEmails,
                          },
                          on: { change: _vm.handleEmailTracking },
                        })
                      }),
                    ],
                    2
                  )
                : _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "disabled dropdown-item",
                        attrs: { disabled: "" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("client-profile.addAgentsToTrackEmails")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-item d-flex flex-column align-items-center no-pointer dropdown-item-fake",
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0 text-justify",
                      staticStyle: { "white-space": "normal" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("client-profile.agentsCanBeAddedToProfile")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }